import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Eiyuden Chronicles Any%" mdxType="SEO" />
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`These notes are very barebones, they assume you know where to go, story triggers, game mechanics, etc.`}</p>
    <p>{`For battles, if a character isn't mentioned, they Defend / Charge Up.`}</p>
    <h3 {...{
      "id": "grum-county-wm"
    }}>{`Grum County WM`}</h3>
    <p>{`Kill the battle with Auto.`}</p>
    <h3 {...{
      "id": "northern-forest"
    }}>{`Northern Forest`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Healing Herbs x6`}</strong><br parentName="p"></br>{`
`}{`Kill both battles to hopefully hit LVL3.`}</p>
    <p>{`Optionally use Recovery Wave to full heal. Or do it manually at the start of the fight.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Revival Medicine x2`}</strong></p>
    <h4 {...{
      "id": "forest-eater-593hp"
    }}>{`Forest Eater 593HP`}</h4>
    <p>{`Recovery Wave T1 if needed, else Auto whole fight.`}</p>
    <p>{`After fight press the switch in the bottom left.`}<br parentName="p"></br>{`
`}{`You can S&Q to avoid the battle here.`}</p>
    <h3 {...{
      "id": "nothern-rune-barrows"
    }}>{`Nothern Rune Barrows`}</h3>
    <p>{`Kill battles till LVL4`}</p>
    <p>{`Get cutscene by orb, it's required.`}<br parentName="p"></br>{`
`}{`Puzzle: Circle `}<em parentName="p">{`textbox`}</em>{`, Triangle, Square.`}</p>
    <p>{`You get auto healed after the drop, including other party members`}</p>
    <p>{`Forced battle 1: Auto`}<br parentName="p"></br>{`
`}{`Forced battle 2: Defend / Auto`}<br parentName="p"></br>{`
`}{`Forced Battle 3: Friendship Combo`}</p>
    <p>{`Get cutscene by orb, it's required.`}<br parentName="p"></br>{`
`}{`Puzzle: Square, Circle, Triangle`}</p>
    <h4 {...{
      "id": "golem-cleaner-p1"
    }}>{`Golem Cleaner P1`}</h4>
    <p>{`Defend all 3 turns.`}</p>
    <h4 {...{
      "id": "golem-cleaner-hp1067"
    }}>{`Golem Cleaner HP1067`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <p>{`Auto`}</p>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <p>{`Defend with front row characters that will die, Hildi Recovery Wave`}</p>
    <h5 {...{
      "id": "turn-3-till-lock-on"
    }}>{`Turn 3 till lock on`}</h5>
    <p>{`Auto`}</p>
    <h5 {...{
      "id": "turn-after-lock-on"
    }}>{`Turn after lock on`}</h5>
    <p>{`Targetted characters Gimmick (Defend if it's center column), rest attack.`}<br parentName="p"></br>{`
`}{`Auto rest of the fight.`}</p>
    <h2 {...{
      "id": "the-watch"
    }}>{`The Watch`}</h2>
    <h3 {...{
      "id": "eltisweiss"
    }}>{`Eltisweiss`}</h3>
    <h4 {...{
      "id": "party"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Garr to Slot 2`}</li>
      <li parentName="ul">{`Lian to Slot 3`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`There's a mechanic / bug here where Yusuke and Francesca don't join you if your front row isn't full.`}</p>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Altverdan`}</strong>{`, recruit `}<strong parentName="p">{`Francesca`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Fort Xialuke`}</strong>{`, recruit `}<strong parentName="p">{`Yusuke`}</strong>{`.`}</p>
    <p>{`Go back to `}<strong parentName="p">{`Eltisweiss`}</strong>{`, recruit `}<strong parentName="p">{`Iugo`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to the Watch HQ for cutscenes.`}</p>
    <h4 {...{
      "id": "blacksmith"
    }}>{`Blacksmith`}</h4>
    <ul>
      <li parentName="ul">{`Nowa: 3`}</li>
      <li parentName="ul">{`Garr: 3`}</li>
      <li parentName="ul">{`Yusuke: 3`}</li>
    </ul>
    <h4 {...{
      "id": "item-shop"
    }}>{`Item Shop`}</h4>
    <ul>
      <li parentName="ul">{`8 Runeshard of Return`}</li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`Altverdan`}</strong>{`.`}</p>
    <h3 {...{
      "id": "altverdan"
    }}>{`Altverdan`}</h3>
    <p>{`Go to building in the top left, talk to the Mayor.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Abandoned Mine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-mine"
    }}>{`Abandoned Mine`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$900`}</strong>{` and then trigger cutscene.`}<br parentName="p"></br>{`
`}{`At fork go right then up, then pull Cart back towards you.`}<br parentName="p"></br>{`
`}{`Go back to 1st fork then go up and right, pick `}<strong parentName="p">{`Earth Rune`}</strong>{`.`}</p>
    <p>{`Use `}<strong parentName="p">{`Runeshard of Return`}</strong>{` to exit the mines. Go to `}<strong parentName="p">{`Altverdan`}</strong>{`.`}</p>
    <h3 {...{
      "id": "altverdan-1"
    }}>{`Altverdan`}</h3>
    <p>{`Go to the Rune Shop`}</p>
    <h4 {...{
      "id": "runeshop"
    }}>{`Runeshop`}</h4>
    <h5 {...{
      "id": "attach"
    }}>{`Attach`}</h5>
    <ul>
      <li parentName="ul">{`Iugo: Earth Slot 1`}</li>
    </ul>
    <h5 {...{
      "id": "sell"
    }}>{`Sell`}</h5>
    <ul>
      <li parentName="ul">{`Ruby Ring`}</li>
      <li parentName="ul">{`Rune of Blind Resistance`}</li>
    </ul>
    <p>{`Go back to `}<strong parentName="p">{`Abandoned Mine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-mine-1"
    }}>{`Abandoned Mine`}</h3>
    <p>{`Progress to next screen.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$900`}</strong>{` next to `}<strong parentName="p">{`Hiro`}</strong>{`. Talk to `}<strong parentName="p">{`Hiro`}</strong>{`.`}</p>
    <h4 {...{
      "id": "hiro-shop"
    }}>{`Hiro Shop`}</h4>
    <h5 {...{
      "id": "buy"
    }}>{`Buy`}</h5>
    <ul>
      <li parentName="ul">{`Healing Herbs: 21, up to 27`}</li>
      <li parentName="ul">{`Revival Medicine: Up to 4`}</li>
      <li parentName="ul">{`Healing Incense: Use rest of money, up to 12.`}</li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`Growth Badge`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Healing Incense`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Iugo: Growth Badge, then remove Growth Badge`}</li>
        <li parentName="ul">{`Repeat this 5 times, until everyone has a Growth Badge.`}</li>
      </ul>
      <h5 {...{
        "id": "battle-plan"
      }}>{`Battle Plan`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`Party Strategy`}</strong>{`: Conserve Resources`}</li>
        <li parentName="ul"><strong parentName="li">{`Nowa`}</strong>{`:`}<ul parentName="li">
            <li parentName="ul"><strong parentName="li">{`Action Limits`}</strong>{`: Conserve SP up to 5`}</li>
            <li parentName="ul"><strong parentName="li">{`Targeting Settings`}</strong>{`: Target Enemy with High Speed`}</li>
          </ul></li>
        <li parentName="ul"><strong parentName="li">{`Garr`}</strong>{`:`}<ul parentName="li">
            <li parentName="ul"><strong parentName="li">{`Action Limits`}</strong>{`: Conserve SP up to 5`}</li>
            <li parentName="ul"><strong parentName="li">{`Targeting Settings`}</strong>{`: Target Different Enemy`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Swap Garr and Francesca`}</li>
      </ul>
    </Menu>
    <p>{`You are now hunting for a 6 Rabbit fight, use a Healing Incense everytime you fail a escape.`}</p>
    <h4 {...{
      "id": "6-rabbits"
    }}>{`6 Rabbits`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Attack Mage S4`}</li>
      <li parentName="ul">{`Francesca: Attack Mage S5`}</li>
      <li parentName="ul">{`Lian: Attack Mage S5`}</li>
      <li parentName="ul">{`Garr: Defend`}</li>
      <li parentName="ul">{`Yusuke: Healing Incense`}</li>
      <li parentName="ul">{`Iugo: Earth Shaker`}</li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`Dash Boots`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Nowa: Remove Growth Badge`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Nowa: Equip Dash Boots`}</li>
        <li parentName="ul">{`Lian: Equip Growth Badge`}</li>
        <li parentName="ul">{`Lian: Remove Growth Badge`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Garr: Equip Dash Boots`}</li>
        <li parentName="ul">{`Iugo: Remove Growth Badge`}</li>
        <li parentName="ul"><em parentName="li">{`If LVL22`}</em>{` Remove Nowa's Headgear and Armor`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`This is so he dies on Elder Dragon`}</p>
      </blockquote>
    </Menu>
    <h4 {...{
      "id": "kogen-1392hp-yuthus-1572hp-zabi-1225hp"
    }}>{`Kogen 1392HP Yuthus 1572HP Zabi 1225HP`}</h4>
    <ul>
      <li parentName="ul">{`Just Garr Attack Yuthus at the start. Once party dies can switch to Auto.`}</li>
      <li parentName="ul">{`Right before you kill Yuthus revive Nowa.`}</li>
      <li parentName="ul">{`Auto until right before you kill Zabi, then revive Nowa again.`}</li>
      <li parentName="ul">{`Finish the battle with Garr and Nowa alive.`}</li>
    </ul>
    <h3 {...{
      "id": "eltisweiss-1"
    }}>{`Eltisweiss`}</h3>
    <h4 {...{
      "id": "party-2"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Lian to Attendant`}</li>
    </ul>
    <p>{`Go to Rune Shop`}</p>
    <h4 {...{
      "id": "rune-shop"
    }}>{`Rune Shop`}</h4>
    <h5 {...{
      "id": "sell-1"
    }}>{`Sell`}</h5>
    <ul>
      <li parentName="ul">{`Growth Badges`}</li>
      <li parentName="ul">{`Runes`}</li>
    </ul>
    <h5 {...{
      "id": "buy-1"
    }}>{`Buy`}</h5>
    <ul>
      <li parentName="ul">{`2 Rune of Power`}</li>
    </ul>
    <p>{`Go to Kyshiri.`}</p>
    <h3 {...{
      "id": "kyshiri"
    }}>{`Kyshiri`}</h3>
    <h4 {...{
      "id": "hurstwine-battle"
    }}>{`Hurstwine Battle`}</h4>
    <ol>
      <li parentName="ol">{`Nowa Attack Bow, Garr Attack Knife in Slot 3`}</li>
      <li parentName="ol">{`Garr Attack Knife`}</li>
      <li parentName="ol">{`Defend`}</li>
    </ol>
    <p>{`Next 3 fights: Auto`}</p>
    <p>{`Go back towards `}<strong parentName="p">{`Eltisweiss`}</strong>{`.`}</p>
    <h3 {...{
      "id": "eltisweiss-2"
    }}>{`Eltisweiss`}</h3>
    <h4 {...{
      "id": "party-3"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Mio to Slot 3`}</li>
    </ul>
    <p>{`Take left path out of town to avoid Mellore cutscenes. Go to `}<strong parentName="p">{`Werne`}</strong>{`.`}</p>
    <h3 {...{
      "id": "werne"
    }}>{`Werne`}</h3>
    <p>{`First 2 Battles: Auto.`}<br parentName="p"></br>{`
`}{`Battle 3: Nowa Attack 4, Garr Attack 3, Mio Attack 2. T2 Auto.`}</p>
    <h3 {...{
      "id": "eltisweiss-3"
    }}>{`Eltisweiss`}</h3>
    <h4 {...{
      "id": "war-battle-the-eltisweiss-front"
    }}>{`War Battle: The Eltisweiss Front`}</h4>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <p>{`Swap Sabine and Nowa`}</p>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <p>{`End Turn`}</p>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <p>{`Face Sabine forward`}</p>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ol>
      <li parentName="ol">{`Nowa Cross Boost and face forward. `}</li>
      <li parentName="ol">{`If Ymir is against 2, Archer Boost`}</li>
    </ol>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <p>{`End Turn`}</p>
    <blockquote>
      <p parentName="blockquote">{`Still need to determine what decides who ends up in your party here.`}<br parentName="p"></br>{`
`}{`Skipped the 1st party menu here once.`}</p>
    </blockquote>
    <h4 {...{
      "id": "party-4"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Garr to Attendant`}</li>
      <li parentName="ul">{`Francesca to Slot 2`}</li>
      <li parentName="ul">{`Yusuke to Slot 5 (1 Up)`}</li>
      <li parentName="ul">{`Swap Yusuke and Mio`}</li>
      <li parentName="ul">{`Swap Yusuke and Nowa`}</li>
    </ul>
    <p>{`Formation should be: Yusuke Francesca Lian Nowa Mio -`}</p>
    <h4 {...{
      "id": "2-sword-2-bow"
    }}>{`2 Sword 2 Bow`}</h4>
    <p>{`T1 Auto. Maybe let it run for T2, then manual commands.`}<br parentName="p"></br>{`
`}{`Goal is to kill off Yusuke, Francesca, and Lian before finishing.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "item"
      }}>{`Item`}</h5>
      <p>{`Healing Incense`}</p>
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Yusuke: Remove Growth Badge`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Yusuke: Equip Growth Badge`}</li>
        <li parentName="ul">{`Yusuke: Remove Growth Badge`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Lian: Equip Growth Badge`}</li>
      </ul>
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Swap Yusuke and Nowa`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "2-sword-1-spear-3-bow"
    }}>{`2 Sword 1 Spear 3 Bow`}</h4>
    <p>{`Open with Auto. Can let it run till all Bow Soldiers are dead. Want to keep the front guys alive for now.`}<br parentName="p"></br>{`
`}{`When low enough, kill 2 Soldiers with Swinging Slash. Let last soldier kill Nowa, then Armor Piercer with Yusuke to finish.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Francesca: Remove Growth Badge`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Lian: Equip Dash Boots`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "seign-duel"
    }}>{`Seign Duel`}</h4>
    <ol>
      <li parentName="ol">{`Counter`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack from now on until you die.`}</li>
    </ol>
    <h3 {...{
      "id": "castle"
    }}>{`Castle`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Lian`}</li>
      <li parentName="ul">{`Go to Great Hall`}</li>
      <li parentName="ul">{`Go to 1st Floor`}</li>
    </ul>
    <p>{`Recruit `}<strong parentName="p">{`Martha`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Abandoned Mine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-mine-2"
    }}>{`Abandoned Mine`}</h3>
    <p>{`Go left, pick `}<strong parentName="p">{`Iron Ore`}</strong>{`. Use `}<strong parentName="p">{`Runeshard of Return`}</strong>{`, go South.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Palenight Mail`}</strong>{` and `}<strong parentName="p">{`Iron Ore`}</strong>{`. Recruit `}<strong parentName="p">{`Ormund`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to South Exit. Talk to `}<strong parentName="p">{`Galdorf`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Exit the mines, go to `}<strong parentName="p">{`Altverdan`}</strong>{`.`}</p>
    <h3 {...{
      "id": "altverdan-2"
    }}>{`Altverdan`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Falward`}</strong>{`. Go to `}<strong parentName="p">{`Werne`}</strong>{`.`}</p>
    <h3 {...{
      "id": "werne-1"
    }}>{`Werne`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Frida`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to `}<strong parentName="p">{`Abandoned Mine`}</strong>{`. Reset steps by entering `}<strong parentName="p">{`Altverdan`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-mine-3"
    }}>{`Abandoned Mine`}</h3>
    <p>{`Recruit `}<strong parentName="p">{`Galdorf`}</strong>{`. Go back to `}<strong parentName="p">{`Castle`}</strong>{`.`}</p>
    <h3 {...{
      "id": "yarnaan"
    }}>{`Yarnaan`}</h3>
    <p>{`Go to Inn on 3rd floor.`}</p>
    <h3 {...{
      "id": "castle-1"
    }}>{`Castle`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Do we start with a random character here?`}</p>
    </blockquote>
    <p>{`Go outside castle and to the right.`}</p>
    <h4 {...{
      "id": "party-6"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Nowa to Attendant`}</li>
      <li parentName="ul">{`Kallathor to Attendant`}</li>
      <li parentName="ul">{`Yusuke to Slot 1`}</li>
      <li parentName="ul">{`Mio to Slot 3`}</li>
      <li parentName="ul">{`Francesca to Slot 4`}</li>
      <li parentName="ul">{`Swap Francesca and Garr `}</li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`The Greatwood - South`}</strong>{`.`}</p>
    <h3 {...{
      "id": "the-greatwood---east"
    }}>{`The Greatwood - East`}</h3>
    <p>{`If you haven't gotten the battle yet, you can S&Q before Ancient Seed to skip it.`}</p>
    <h4 {...{
      "id": "ancient-seed-1837hp"
    }}>{`Ancient Seed 1837HP`}</h4>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`All Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Francesca Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Both Attack (Yusuke is short without crit, attack for chance of crit)`}</li>
    </ul>
    <h3 {...{
      "id": "treefolk-village"
    }}>{`Treefolk Village`}</h3>
    <h4 {...{
      "id": "party-7"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Garoo to Attendant`}</li>
      <li parentName="ul">{`Marisa to Slot 5`}</li>
    </ul>
    <p>{`Go to Rune Shop`}</p>
    <h4 {...{
      "id": "rune-shop-1"
    }}>{`Rune Shop`}</h4>
    <h5 {...{
      "id": "sell-2"
    }}>{`Sell`}</h5>
    <ul>
      <li parentName="ul">{`Growth Badges`}</li>
      <li parentName="ul">{`Nova's Armor if removed`}</li>
    </ul>
    <h5 {...{
      "id": "buy-2"
    }}>{`Buy`}</h5>
    <ul>
      <li parentName="ul">{`1 Rune of Fire`}</li>
      <li parentName="ul">{`2 Rune of Earth`}</li>
    </ul>
    <h5 {...{
      "id": "change"
    }}>{`Change`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: `}<ul parentName="li">
          <li parentName="ul">{`Slot 1: Remove Rune of Armor Pierce`}</li>
          <li parentName="ul">{`Slot 2: Rune of Power`}</li>
        </ul></li>
      <li parentName="ul">{`Mio:`}<ul parentName="li">
          <li parentName="ul">{`Slot 1: Rune of Fire`}</li>
        </ul></li>
      <li parentName="ul">{`Garr:`}<ul parentName="li">
          <li parentName="ul">{`Slot 2: Rune of Power`}</li>
          <li parentName="ul">{`Slot 3: Rune of SP: Power`}</li>
          <li parentName="ul">{`Slot 4: Rune of SP: Power (Marisa's)`}</li>
        </ul></li>
    </ul>
    <p>{`Go to the `}<strong parentName="p">{`Proving Grounds`}</strong></p>
    <h3 {...{
      "id": "road-to-the-proving-grounds"
    }}>{`Road to the Proving Grounds`}</h3>
    <p>{`Path is to hug leftish then hard left at the start.`}</p>
    <h3 {...{
      "id": "proving-grounds"
    }}>{`Proving Grounds`}</h3>
    <h4 {...{
      "id": "gear-1"
    }}>{`Gear 1`}</h4>
    <ul>
      <li parentName="ul">{`2 Spins: Take first left. Go down to helicopter flower.`}</li>
      <li parentName="ul">{`Puzzle: M R M L, Pick `}<strong parentName="li">{`Ruby Bangle`}</strong>{`, L L M`}</li>
      <li parentName="ul">{`After activating gear  on left `}<strong parentName="li">{`Runeshard of Return`}</strong></li>
    </ul>
    <h4 {...{
      "id": "gear-2"
    }}>{`Gear 2`}</h4>
    <ul>
      <li parentName="ul">{`2 Spins: Take first left. Then go up and right to re-enter main hall. Take right path, down to helicopter flower.`}</li>
      <li parentName="ul">{`Puzzle: L R M`}</li>
      <li parentName="ul">{`After activating gear on right `}<strong parentName="li">{`Runeshard of Return`}</strong></li>
    </ul>
    <h4 {...{
      "id": "sigil-1"
    }}>{`Sigil 1`}</h4>
    <ul>
      <li parentName="ul">{`1 Spin: Enter middle left side to reset steps, then go end left. Take helicopter flower.`}</li>
      <li parentName="ul">{`Activate Sigil, then `}<strong parentName="li">{`Runeshard of Return`}</strong>{`.`}</li>
    </ul>
    <h4 {...{
      "id": "sigil-2"
    }}>{`Sigil 2`}</h4>
    <ul>
      <li parentName="ul">{`1 Spin: Enter beginning left, then go forward and right to re-enter main hall. Take top right path. Take helicopter flower.`}</li>
      <li parentName="ul">{`Activate Sigil, then `}<strong parentName="li">{`Runeshard of Return`}</strong>{`.`}</li>
    </ul>
    <p>{`3 Spin: Then go forward.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Garr: Remove Dash Boots`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Yusuke: Equip Dash Boots `}</li>
        <li parentName="ul">{`Yusuke: Remove Dash Boots`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Yusuke: Equip Ruby Brooch`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "astrea-the-judge-2152hp"
    }}>{`Astrea the Judge 2152HP`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Garr Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr Attack if Francesca is still alive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Auto / All Attack`}</li>
    </ul>
    <h4 {...{
      "id": "hurstwine-1542hp-narungarde-1883hp"
    }}>{`Hurstwine 1542HP Narungarde 1883HP`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <p>{`Garr Attack Hurstwine, Mio Flaming Sword Yusuke`}</p>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <p>{`Auto / Yusuke and Garr Attack`}</p>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <p>{`Auto / Garr Attack and Yusuke Charge, Auto next turn`}</p>
    <h2 {...{
      "id": "euchriss"
    }}>{`Euchriss`}</h2>
    <p>{`You don't get auto-healed afterwards, so Mio is still low HP/MP`}</p>
    <h3 {...{
      "id": "castle-2"
    }}>{`Castle`}</h3>
    <h4 {...{
      "id": "party-8"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Nowa to Attendant`}</li>
      <li parentName="ul">{`Yusuke to Slot 1`}</li>
      <li parentName="ul">{`Lian to Attendant (left)`}</li>
      <li parentName="ul">{`Francesca to Slot 3`}</li>
      <li parentName="ul">{`Garr to Slot 4`}</li>
      <li parentName="ul">{`Swap Garr and Sabine`}</li>
      <li parentName="ul">{`Mio to Slot 6`}</li>
    </ul>
    <p>{`Go back to the `}<strong parentName="p">{`Greatwood - East`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Hishahn`}</strong>{`.`}</p>
    <h3 {...{
      "id": "the-greatwood"
    }}>{`The Greatwood`}</h3>
    <p>{`On the last screen, before exiting to WM, can S&Q at last save point to skip battle.`}</p>
    <h3 {...{
      "id": "hishahn"
    }}>{`Hishahn`}</h3>
    <p>{`Recruit Carrie:`}<br parentName="p"></br>{`
`}{`1. Go up at 1st fork`}<br parentName="p"></br>{`
`}{`2. Go right till past Item Shop then up.`}<br parentName="p"></br>{`
`}{`3. Go back down left, before Blacksmith go down`}</p>
    <p>{`Go to Blacksmith.`}</p>
    <h4 {...{
      "id": "blacksmith-1"
    }}>{`Blacksmith`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: 6`}</li>
      <li parentName="ul">{`Garr: 6`}</li>
    </ul>
    <p>{`After Blacksmith, go left, up, right to inn.`}</p>
    <h4 {...{
      "id": "party-9"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Perielle: Slot 4`}</li>
      <li parentName="ul">{`Carrie: Slot 5`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Perielle apparently auto-joins if you have an empty slot later, or gives you a party menu if you don't.`}</p>
    </blockquote>
    <p>{`After "It was all for her" cutscene, teleport to `}<strong parentName="p">{`Hishahn 1R1U`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Run around and enter Hishahn from the other side`}</strong>{`.`}</p>
    <p>{`Melridge cutscene, head to `}<strong parentName="p">{`Hishahn Old Town`}</strong>{`.`}</p>
    <h3 {...{
      "id": "hishahn-old-town"
    }}>{`Hishahn Old Town`}</h3>
    <h4 {...{
      "id": "pagurian-3841hp"
    }}>{`Pagurian 3841HP`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Carrie: Attack`}</li>
      <li parentName="ul">{`Mio: Fire God's Sword Yusuke`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Carrie: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Garr: Double Slash / Attack`}</li>
      <li parentName="ul">{`Carrie: Attack`}</li>
    </ul>
    <h3 {...{
      "id": "hishahn-1"
    }}>{`Hishahn`}</h3>
    <p>{`After night cutscene, go to Palace.next time you end up in your Palace Room, Teleport `}<strong parentName="p">{`Hishahn 1R2U`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Hishahn`}</strong>{`, run to the inn.`}</p>
    <h4 {...{
      "id": "war-hishahn-front-1"
    }}>{`War: Hishahn Front 1`}</h4>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <p>{`Move Kassius 1 Up (not towards enemies)`}</p>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <p>{`Wait`}</p>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move 1 Up`}</li>
      <li parentName="ul">{`Ymir: Move 1 Up`}</li>
      <li parentName="ul">{`Kassius: Scheme on Seign then move 1 Up`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <p>{`Wait`}</p>
    <h4 {...{
      "id": "war-hishahn-front-2"
    }}>{`War: Hishahn Front 2`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <p>{`Move all 1 Right`}</p>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <p>{`Move all 1 Right`}</p>
    <h5 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Nowa:`}<ul parentName="li">
          <li parentName="ul">{`Move 1 Right`}</li>
          <li parentName="ul">{`Cross Boost`}</li>
        </ul></li>
      <li parentName="ul">{`Kassius:`}<ul parentName="li">
          <li parentName="ul">{`Move 1 Up`}</li>
          <li parentName="ul">{`Scheme bottom enemies`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move 1 Up`}</li>
      <li parentName="ul">{`Ymir: Move 1 Up`}</li>
      <li parentName="ul">{`Kassius: Move 1 Up`}</li>
    </ul>
    <h2 {...{
      "id": "shiarc-campaign"
    }}>{`Shi'arc Campaign`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Fully healed at the start.`}</p>
    </blockquote>
    <h3 {...{
      "id": "castle-3"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}</p>
    <h4 {...{
      "id": "party-10"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Nowa: Attendant`}</li>
      <li parentName="ul">{`Barnard: Attendant`}</li>
      <li parentName="ul">{`Francesca: Slot 1`}</li>
      <li parentName="ul">{`Yusuke: Slot 2`}</li>
      <li parentName="ul">{`Mio: Slot 4`}</li>
      <li parentName="ul">{`Garr: Slot 5`}</li>
    </ul>
    <p>{`Teleport to `}<strong parentName="p">{`Hishahn 1R2U`}</strong>{`, go to `}<strong parentName="p">{`Shandar Ridge`}</strong></p>
    <h3 {...{
      "id": "shandar-ridge"
    }}>{`Shandar Ridge`}</h3>
    <h4 {...{
      "id": "surkkamui-4187hp"
    }}>{`Surkkamui 4187HP`}</h4>
    <p>{`Can take up to 3-5 turns, based on his targeting and crits.`}</p>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Mio: Fire God's Sword Garr`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Mio: Fire God's Sword Yusuke`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-7"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Attacks/Double Slash / Auto`}</li>
    </ul>
    <p>{`After cutscene, pick `}<strong parentName="p">{`Magical Holy Water`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Dabavin`}</strong>{`.`}</p>
    <h3 {...{
      "id": "dabavin"
    }}>{`Dabavin`}</h3>
    <p>{`Go straight to Scarlet to go to `}<strong parentName="p">{`Impershi'arc`}</strong>{`.`}</p>
    <h3 {...{
      "id": "impershiarc"
    }}>{`Impershi'arc`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Shoalmeister`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Rune Shop`}</p>
    <h4 {...{
      "id": "rune-shop-2"
    }}>{`Rune Shop`}</h4>
    <h5 {...{
      "id": "buy-3"
    }}>{`Buy`}</h5>
    <ul>
      <li parentName="ul">{`8 Rune of Mighty Power`}</li>
    </ul>
    <p>{`Talk to `}<strong parentName="p">{`Yuferius`}</strong>{`. Give up instantly on practice race.`}<br parentName="p"></br>{`
`}{`Go to inn. `}</p>
    <h4 {...{
      "id": "race"
    }}>{`Race`}</h4>
    <p>{`Use D-Pad. Go fast. After 1st jump, might be better to go more right and head straight for the shortcut.`}</p>
    <p>{`Teleport to `}<strong parentName="p">{`Inside Castle 1R`}</strong>{`.`}</p>
    <h3 {...{
      "id": "castle-4"
    }}>{`Castle`}</h3>
    <p>{`Talk to Sumire`}</p>
    <h4 {...{
      "id": "storehouse"
    }}>{`Storehouse`}</h4>
    <h5 {...{
      "id": "change-gear---runes"
    }}>{`Change Gear - Runes`}</h5>
    <ul>
      <li parentName="ul">{`Garr:`}<ul parentName="li">
          <li parentName="ul">{`Slot 2: Rune of Mighty Power`}</li>
        </ul></li>
      <li parentName="ul">{`Yuferius:`}<ul parentName="li">
          <li parentName="ul">{`Slot 1: Rune of Mighty Power`}</li>
          <li parentName="ul">{`Slot 3: Rune of Mighty Power`}</li>
        </ul></li>
      <li parentName="ul">{`Iugo: Unequip`}</li>
      <li parentName="ul">{`Yusuke:`}<ul parentName="li">
          <li parentName="ul">{`Slot 2: Rune of Mighty Power`}</li>
        </ul></li>
      <li parentName="ul">{`Seign:`}<ul parentName="li">
          <li parentName="ul">{`Slot 2: Rune of Earth`}</li>
          <li parentName="ul">{`Slot 3: Rune of Mighty Power`}</li>
          <li parentName="ul">{`Slot 4: Rune of Mighty Power`}</li>
        </ul></li>
      <li parentName="ul">{`Hildi:`}<ul parentName="li">
          <li parentName="ul">{`Slot 1: Rune of Fire`}</li>
          <li parentName="ul">{`Slot 3: Rune of Earth`}</li>
        </ul></li>
      <li parentName="ul">{`Valentine:`}<ul parentName="li">
          <li parentName="ul">{`Slot 1: Rune of Sleep Slash`}</li>
          <li parentName="ul"><strong parentName="li">{`Slot 3`}</strong>{`: Rune of Earth`}</li>
        </ul></li>
      <li parentName="ul">{`Melridge: Unequip`}</li>
    </ul>
    <h5 {...{
      "id": "sell---bag---gear"
    }}>{`Sell - Bag - Gear`}</h5>
    <p><strong parentName="p">{`Keep below`}</strong>{`, sell everything else.`}</p>
    <ul>
      <li parentName="ul">{`Golden Scale Armor`}</li>
      <li parentName="ul">{`Dash Boots`}</li>
      <li parentName="ul">{`Ruby Brooch.`}</li>
      <li parentName="ul">{`Rune of Mighty Power`}</li>
    </ul>
    <p>{`Talk to `}<strong parentName="p">{`Hildi`}</strong>{` to start Seign Campaign.`}</p>
    <h2 {...{
      "id": "seign-campaign"
    }}>{`Seign Campaign`}</h2>
    <h3 {...{
      "id": "ardinale"
    }}>{`Ardinale`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Seign: Equip Dash Boots`}</li>
      </ul>
    </Menu>
    <p>{`Go to Item Shop in Low Town, get rest of your party.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Valentine: Equip Ruby Brooch`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Yaelu: Equip Dash Boots`}</li>
        <li parentName="ul">{`Yaelu: Remove Dash Boots`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Yaelu: Equip Dash Boots`}</li>
        <li parentName="ul">{`Valentine: Remove Ruby Brooch`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Ivy: Equip Ruby Brooch`}</li>
        <li parentName="ul">{`Ivy: Remove Ruby Brooch`}</li>
        <li parentName="ul">{`Yaelu: Remove Dash Boots`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "rune-research-lab"
    }}>{`Rune Research Lab`}</h3>
    <h4 {...{
      "id": "right-screen"
    }}>{`Right Screen`}</h4>
    <ul>
      <li parentName="ul">{`Pick 1st Chest for `}<strong parentName="li">{`Red Key`}</strong>{`.`}</li>
      <li parentName="ul">{`Go to top left of this screen, open door and pick `}<strong parentName="li">{`Blue Key`}</strong>{`.`}</li>
      <li parentName="ul">{`Go to middle, open door and go to left screen.`}</li>
    </ul>
    <h4 {...{
      "id": "middle-screen"
    }}>{`Middle Screen`}</h4>
    <ul>
      <li parentName="ul">{`Go down and pick `}<strong parentName="li">{`Mystical Magic Medicine`}</strong>{`.`}</li>
      <li parentName="ul">{`Go to top left door.`}</li>
    </ul>
    <h4 {...{
      "id": "2-wandering-golem-320hp-1-assault-cleaner-515hp-2-lesser-demon-320hp"
    }}>{`2 Wandering Golem 320HP 1 Assault Cleaner 515HP 2 Lesser Demon 320HP`}</h4>
    <p>{`Ivy & Yaelu attack Assault Cleaner, rest do Earth Shaker`}</p>
    <h4 {...{
      "id": "left-screen"
    }}>{`Left Screen`}</h4>
    <ul>
      <li parentName="ul">{`Pick chest in top left for `}<strong parentName="li">{`Red Key`}</strong>{`.`}</li>
      <li parentName="ul">{`Pick chest in bottom right for `}<strong parentName="li">{`Blue Key`}</strong></li>
      <li parentName="ul">{`Pick chest in middle left for `}<strong parentName="li">{`Crankshaft`}</strong></li>
      <li parentName="ul">{`Go back to top right to middle screen`}</li>
    </ul>
    <h4 {...{
      "id": "middle-screen-1"
    }}>{`Middle Screen`}</h4>
    <ul>
      <li parentName="ul">{`Insert Crankshaft into top right slot.`}</li>
    </ul>
    <h4 {...{
      "id": "duel-seign-vs-aldric"
    }}>{`Duel: Seign vs Aldric`}</h4>
    <blockquote>
      <p parentName="blockquote">{`5 atk: 1:36. intentional loss: 1:34, 1:23`}<br parentName="p"></br>{`
`}{`Easy way to do this fight is just mash X. Should get about a 1:34.`}<br parentName="p"></br>{`
`}{`Going for the loss is potentially faster, instructions are for going for the loss.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Counter`}</li>
      <li parentName="ol">{`Counter`}</li>
      <li parentName="ol">{`Attack`}</li>
    </ol>
    <p>{`Easy way to remember this is "keep your hands clean" = attack, anything else is counter.`}<br parentName="p"></br>{`
`}{`Keep an eye on your tension / his HP! Cursor will go to break automatically when it's available.`}</p>
    <ul>
      <li parentName="ul">{`Greater Good!: Counter`}</li>
      <li parentName="ul">{`Learn your place: Counter`}</li>
      <li parentName="ul">{`Keep your hands clean: Attack`}</li>
    </ul>
    <p><strong parentName="p">{`Talk to bottom-right villager for full heal.`}</strong><br parentName="p"></br>{`
`}{`Talk to Pohl to start bridge gauntlet.`}</p>
    <h4 {...{
      "id": "modified-specimen-w_1155-1340hp"
    }}>{`Modified Specimen W_1155 1340HP`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Sword Rain / Attack`}</li>
      <li parentName="ul">{`Valentine: Sleep Slash / Attack`}</li>
      <li parentName="ul">{`Ivy: Defend`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Seign`}</li>
      <li parentName="ul">{`Pohl: Rock Thrust`}</li>
      <li parentName="ul">{`Yaelu: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2--on"
    }}>{`Turn 2 & on`}</h5>
    <p>{`Same, except Hildi does Fireball. Ivy can heal if needed.`}</p>
    <h4 {...{
      "id": "heavy-modified-specimen-b_1929-1409hp"
    }}>{`Heavy Modified Specimen B_1929 1409HP`}</h4>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Sword Rain / Rock Thrust`}</li>
      <li parentName="ul">{`Valentine: Sleep Slash / Rock Thrust`}</li>
      <li parentName="ul">{`Ivy: Magic Holy Water Hildi`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Seign`}</li>
      <li parentName="ul">{`Pohl: Rock Thrust`}</li>
      <li parentName="ul">{`Yaelu: Recovery Incense`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Sword Rain / Attack`}</li>
      <li parentName="ul">{`Valentine: Sleep Slash / Attack`}</li>
      <li parentName="ul">{`Ivy: Recovery Incense`}</li>
      <li parentName="ul">{`Hildi: Fireball`}</li>
      <li parentName="ul">{`Pohl: Attack`}</li>
      <li parentName="ul">{`Yaelu: Attack / Mystical Magic Medicine Pohl when he is on his last cast.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on"
    }}>{`Turn 3 & on`}</h5>
    <p>{`If Enemy is 1st, don't do normal attacks with melee characters. Keep DPSing.`}</p>
    <h4 {...{
      "id": "synthetic-specimen-r_0812-1753hp"
    }}>{`Synthetic Specimen R_0812 1753HP`}</h4>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Sword Rain / Attack`}</li>
      <li parentName="ul">{`Valentine: Sleep Slash / Attack`}</li>
      <li parentName="ul">{`Ivy: Defend`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Seign`}</li>
      <li parentName="ul">{`Pohl: Attack`}</li>
      <li parentName="ul">{`Yaelu: Attack`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`You can burn all MP here.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Sword Rain / Attack`}</li>
      <li parentName="ul">{`Valentine: Sleep Slash / Attack`}</li>
      <li parentName="ul">{`Ivy: Spirit Medicine`}</li>
      <li parentName="ul">{`Hildi: Rock Thrust`}</li>
      <li parentName="ul">{`Pohl: Attack`}</li>
      <li parentName="ul">{`Yaelu: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on-1"
    }}>{`Turn 3 & On`}</h5>
    <p>{`Keep DPSing`}</p>
    <h4 {...{
      "id": "chimera-4837hp"
    }}>{`Chimera 4837HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`TODO: Try to make a battle plan setup geared towards this fight.`}<br parentName="p"></br>{`
`}{`Can see issues with preventing skill usage for Seign & Valentin, but otherwise T1-T7 should be doable.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Attack`}</li>
      <li parentName="ul">{`Valentine: Attack`}</li>
      <li parentName="ul">{`Ivy: Recovery Incense`}</li>
      <li parentName="ul">{`Hildi: Dodge`}</li>
      <li parentName="ul">{`Pohl: Defend`}</li>
      <li parentName="ul">{`Yaelu: Gimmick when available/ Dodge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7-1"
    }}>{`Turn 2-7`}</h5>
    <p>{`Same as T1, except Ivy Defends.`}</p>
    <h5 {...{
      "id": "turn-8-9"
    }}>{`Turn 8-9`}</h5>
    <p>{`All Defend`}</p>
    <h5 {...{
      "id": "turn-10"
    }}>{`Turn 10`}</h5>
    <p>{`Yaelu Gimmick`}</p>
    <h3 {...{
      "id": "castle-5"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Go to your room.`}</p>
    <h2 {...{
      "id": "athrabalt-campaign"
    }}>{`Athrabalt Campaign`}</h2>
    <p>{`Teleport `}<strong parentName="p">{`Castle 1U`}</strong>{`.`}</p>
    <p>{`Re-enter Castle, move forward a bit, and run back out.`}<br parentName="p"></br>{`
`}{`Re-enter Castle. Should trigger cutscene.`}</p>
    <p>{`Teleport `}<strong parentName="p">{`Inside Castle 1R`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Great Hall.`}</p>
    <h4 {...{
      "id": "party-11"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Marisa: Attendant`}</li>
      <li parentName="ul">{`Francesca: Slot 2`}</li>
      <li parentName="ul">{`Garoo: Attendant`}</li>
      <li parentName="ul">{`Yusuke: Slot 3`}</li>
      <li parentName="ul">{`Yusuke swap Nowa`}</li>
      <li parentName="ul">{`Garr: Slot 4`}</li>
      <li parentName="ul">{`Hildi: Slot 5`}</li>
      <li parentName="ul">{`Yuferius: Slot 6`}</li>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <p>{`Teleport `}<strong parentName="p">{`The Greatwood - East 1R1D`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run to `}<strong parentName="p">{`Eldroad`}</strong>{`.`}</p>
    <h3 {...{
      "id": "eldroad"
    }}>{`Eldroad`}</h3>
    <h4 {...{
      "id": "elder-dragon-3577hp"
    }}>{`Elder Dragon 3577HP`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<strong parentName="li">{`Attack`}</strong></li>
      <li parentName="ul">{`Hildi: Flame God's Sword Garr`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Hildi: Flame God's Sword Yusuke`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-8"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`Blood-stained Helmet`}</strong></p>
    <blockquote>
      <p parentName="blockquote">{`Garr Attack: 370 @LV83`}</p>
    </blockquote>
    <h4 {...{
      "id": "4-corpse-knight-885hp-lv42"
    }}>{`4 Corpse Knight 885HP LV42`}</h4>
    <p>{`Ideally both Nowa and Francesca die here, but it's fine if they don't`}</p>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Attack 1`}</li>
      <li parentName="ul">{`Garr: Attack 1`}</li>
      <li parentName="ul">{`Yuferius: Healing Incense`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Garr`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack 1`}</li>
      <li parentName="ul">{`Yusuke: Attack 2`}</li>
      <li parentName="ul">{`Yuferius: Attack 2`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Yusuke`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--4"
    }}>{`Turn 3 & 4`}</h5>
    <p>{`Attack`}</p>
    <h4 {...{
      "id": "party-12"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Nil: Attendant`}</li>
      <li parentName="ul">{`Francesca: Swap Yuferius`}</li>
      <li parentName="ul">{`Nowa: Swap Hildi`}</li>
      <li parentName="ul">{`Hildi: Swap Alwe`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Garr: Equip Blood-stained Helmet`}</li>
        <li parentName="ul">{`Garr: Remove Blood-stained Helmet`}</li>
        <li parentName="ul">{`Auto Equip Party`}</li>
        <li parentName="ul">{`Garr:`}<ul parentName="li">
            <li parentName="ul">{`Equip: Blood-stained Helmet`}</li>
            <li parentName="ul">{`Equip: Dash Boots`}</li>
          </ul></li>
        <li parentName="ul">{`Alwe: Equip Dash Boots`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Athrabalt`}</strong></p>
    <h3 {...{
      "id": "athrabalt"
    }}>{`Athrabalt`}</h3>
    <p>{`Go to Blacksmith`}</p>
    <h4 {...{
      "id": "blacksmith-2"
    }}>{`Blacksmith`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: 10`}</li>
      <li parentName="ul">{`Yuferius: 10`}</li>
      <li parentName="ul">{`Alwe: 10`}</li>
      <li parentName="ul">{`Garr: 10`}</li>
    </ul>
    <p>{`Go to Palace`}</p>
    <h4 {...{
      "id": "party-13"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Maxim: Attendant`}</li>
      <li parentName="ul">{`Rudy: Attendant`}</li>
    </ul>
    <p>{`Teleport to `}<strong parentName="p">{`Athrabalt 2R1U`}</strong>{`, go to `}<strong parentName="p">{`Ice Cave`}</strong></p>
    <h3 {...{
      "id": "ice-cave"
    }}>{`Ice Cave`}</h3>
    <p><em parentName="p">{`To break out of Ice, it's approximately 13 left-rights. I recommend doing 10, then doing the last 3 when it's time to break out`}</em></p>
    <h4 {...{
      "id": "fenrir-5563hp"
    }}>{`Fenrir 5563HP`}</h4>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Alwe: Gimmick`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alwe: Fire God's Sword Yusuke`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Nowa: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-9"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
      <li parentName="ul">{`Alwe: Fire God's Sword Yuferius`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <p>{`Teleport to `}<strong parentName="p">{`Athrabalt 2R3D`}</strong>{`.`}</p>
    <h3 {...{
      "id": "athrabalt-1"
    }}>{`Athrabalt`}</h3>
    <p>{`Go to Palace.`}</p>
    <h4 {...{
      "id": "party-14"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Rudy: swap Nil`}</li>
    </ul>
    <p>{`Teleport to `}<strong parentName="p">{`Athrabalt 2R3D`}</strong>{`, go to `}<strong parentName="p">{`Yarnaan`}</strong></p>
    <h3 {...{
      "id": "yarnaan-1"
    }}>{`Yarnaan`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Corpse Guard: 447HP, Crimson Nova: 80-95, Wind God's Breath: 59`}<br parentName="p"></br>{`
`}{`Corpse Witch: 304HP, Crimson Nova: 108, Wind God's Breath: 57`}</p>
    </blockquote>
    <h4 {...{
      "id": "party-15"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Alwe: Swap Garr`}</li>
      <li parentName="ul">{`Francesca: Swap Lilwn`}</li>
      <li parentName="ul">{`Nowa: Swap Marisa`}</li>
    </ul>
    <h4 {...{
      "id": "3-corpse-guard"
    }}>{`3 Corpse Guard`}</h4>
    <h5 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack 1`}</li>
      <li parentName="ul">{`Garr: Attack 3`}</li>
      <li parentName="ul">{`Yuferius: Attack 1`}</li>
      <li parentName="ul">{`Lilwn: Attack 1`}</li>
      <li parentName="ul">{`Alwe: Attack 3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack 2`}</li>
      <li parentName="ul">{`Garr: Attack 2`}</li>
      <li parentName="ul">{`Yuferius: Attack 3`}</li>
    </ul>
    <h4 {...{
      "id": "2-corpse-guard-2-corpse-witch"
    }}>{`2 Corpse Guard 2 Corpse Witch`}</h4>
    <h5 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Guard 1`}</li>
      <li parentName="ul">{`Yuferius: Attack Witch 2`}</li>
      <li parentName="ul">{`Garr: Attack Witch 1`}</li>
      <li parentName="ul">{`Alwe: Attack Witch 2`}</li>
      <li parentName="ul">{`Lilwn: Attack Witch 2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-15"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Guard 2`}</li>
      <li parentName="ul">{`Yuferius: Attack Guard 1`}</li>
      <li parentName="ul">{`Garr: Attack Guard 2`}</li>
      <li parentName="ul">{`Alwe: Attack Guard 1`}</li>
    </ul>
    <h4 {...{
      "id": "3-corpse-witch"
    }}>{`3 Corpse Witch`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: Attack 2`}</li>
      <li parentName="ul">{`Yuferius: Attack 1`}</li>
      <li parentName="ul">{`Garr: Attack 3`}</li>
      <li parentName="ul">{`Rest: Attack 1`}</li>
    </ul>
    <h4 {...{
      "id": "1-corpse-guard-4-corpse-witch"
    }}>{`1 Corpse Guard 4 Corpse Witch`}</h4>
    <h5 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Witch 1`}</li>
      <li parentName="ul">{`Yuferius: Attack Witch 4`}</li>
      <li parentName="ul">{`Garr: Attack Witch 3`}</li>
      <li parentName="ul">{`Lilwn: Attack Witch 4`}</li>
      <li parentName="ul">{`Alwe: Attack Witch 4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-16"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Guard`}</li>
      <li parentName="ul">{`Garr: Attack Witch`}</li>
      <li parentName="ul">{`Yuferius: Attack Guard`}</li>
      <li parentName="ul">{`Alwe: Attack Guard`}</li>
    </ul>
    <h4 {...{
      "id": "2-guard-2-witch"
    }}>{`2 Guard 2 Witch`}</h4>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Guard 1`}</li>
      <li parentName="ul">{`Yuferius: Attack Witch 2`}</li>
      <li parentName="ul">{`Garr: Attack Witch 1`}</li>
      <li parentName="ul">{`Alwe: Attack Witch 2`}</li>
      <li parentName="ul">{`Lilwn: Attack Witch 2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-17"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Guard 2`}</li>
      <li parentName="ul">{`Yuferius: Attack Guard 1`}</li>
      <li parentName="ul">{`Garr: Attack Guard 2`}</li>
      <li parentName="ul">{`Alwe: Attack Guard 1`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Should bring Nil instead of Marisa, and have her Fire Sword Garr`}</p>
    </blockquote>
    <h4 {...{
      "id": "3-guard-3-witch"
    }}>{`3 Guard 3 Witch`}</h4>
    <h5 {...{
      "id": "turn-1-21"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke Attack Guard 1`}</li>
      <li parentName="ul">{`Yuferius Attack Witch 3`}</li>
      <li parentName="ul">{`Garr Attack Witch 2`}</li>
      <li parentName="ul">{`Alwe Attack Witch 3`}</li>
      <li parentName="ul">{`Lilwn Attack Witch 3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-18"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr Attack Witch 1`}</li>
      <li parentName="ul">{`Wing the rest`}</li>
    </ul>
    <p>{`Run to `}<strong parentName="p">{`Athrabalt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "athrabalt-2"
    }}>{`Athrabalt`}</h3>
    <p>{`Go to Blacksmith `}</p>
    <h4 {...{
      "id": "blacksmith-3"
    }}>{`Blacksmith`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: 12`}</li>
      <li parentName="ul">{`Yuferius: 12`}</li>
      <li parentName="ul">{`Garr: 12`}</li>
    </ul>
    <p>{`Go to Palace.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Marisa's group leaves your party after going to the Palace. Only Garr, Yusuke, and Yuferius left in the party.`}</p>
    </blockquote>
    <p>{`Teleport to `}<strong parentName="p">{`Athrabalt 3R3D`}</strong>{` and re-enter.`}<br parentName="p"></br>{`
`}{`Go to Palace.`}</p>
    <h4 {...{
      "id": "party-16"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: Swap Seign`}</li>
      <li parentName="ul">{`Seign: Swap Nowa`}</li>
      <li parentName="ul">{`Attendant: Marisa`}</li>
    </ul>
    <p>{`Teleport to `}<strong parentName="p">{`Yarnaan 3R2D`}</strong>{`. Go to `}<strong parentName="p">{`Snowpeak Pass`}</strong>{`.`}</p>
    <h3 {...{
      "id": "snowpeak-pass"
    }}>{`Snowpeak Pass`}</h3>
    <h4 {...{
      "id": "seign-party"
    }}>{`Seign Party`}</h4>
    <ul>
      <li parentName="ul">{`Yusuke: Slot 5`}</li>
    </ul>
    <h4 {...{
      "id": "marisa-party"
    }}>{`Marisa Party`}</h4>
    <p>{`No Change`}</p>
    <h4 {...{
      "id": "equipment-8"
    }}>{`Equipment`}</h4>
    <ul>
      <li parentName="ul">{`Auto Equip Party`}</li>
      <li parentName="ul">{`Marisa: Equip Dash Boots`}</li>
    </ul>
    <h4 {...{
      "id": "party-17"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Leene: Slot 4`}</li>
    </ul>
    <p>{`Take left at first fork.`}</p>
    <h4 {...{
      "id": "nowa-party"
    }}>{`Nowa Party`}</h4>
    <ul>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <p>{`OR for guaranteed flee`}</p>
    <ul>
      <li parentName="ul">{`Nowa: Attendant`}</li>
      <li parentName="ul">{`Alwe: Slot 1`}</li>
      <li parentName="ul">{`Lian: Attendant`}</li>
      <li parentName="ul">{`Lilwn: Slot 3`}</li>
      <li parentName="ul">{`Mio: Attendant`}</li>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <h4 {...{
      "id": "heinrich"
    }}>{`Heinrich`}</h4>
    <p>{`Defend all 3 turns.`}</p>
    <p>{`Run back to `}<strong parentName="p">{`Athrabalt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "athrabalt-3"
    }}>{`Athrabalt`}</h3>
    <p>{`Go to Palace.`}<br parentName="p"></br>{`
`}{`Teleport to `}<strong parentName="p">{`Athrabalt 2R3D`}</strong>{`, re-enter.`}<br parentName="p"></br>{`
`}{`Go to Palace.`}</p>
    <h4 {...{
      "id": "war-battle-of-athrabalt-1"
    }}>{`War: Battle of Athrabalt 1`}</h4>
    <ul>
      <li parentName="ul">{`Barnard: Move 2 Right to Kassius`}</li>
      <li parentName="ul">{`Seign: Move 2 Left to Nowa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa: Move Forward`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-19"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Cross Boost`}</li>
      <li parentName="ul">{`Marisa: Assault Chappel`}</li>
      <li parentName="ul">{`Seign: Focus Attacks Chappel`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-10"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Scheme Heinrich`}</li>
        </ul></li>
      <li parentName="ul">{`Marisa: Move Forward`}</li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "war-battle-of-athrabalt-2"
    }}>{`War: Battle of Athrabalt 2`}</h4>
    <p>{`Wait twice`}</p>
    <h3 {...{
      "id": "seign-group"
    }}>{`Seign Group`}</h3>
    <h4 {...{
      "id": "party-18"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Seign: Attendant`}</li>
      <li parentName="ul">{`Yusuke: Slot 1`}</li>
      <li parentName="ul">{`Valentine: Attendant`}</li>
      <li parentName="ul">{`Pohl: Attendant`}</li>
      <li parentName="ul">{`Francesca: Slot 4`}</li>
      <li parentName="ul">{`Francesca: Swap Hildi`}</li>
    </ul>
    <h4 {...{
      "id": "maiden-revenant-4211hp"
    }}>{`Maiden Revenant 4211HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Want 2 max damage attacks with Yusuke, +some chip damage. So need to revive Francesca once, and do 2 Sword of Fires, with the 2nd one T3 at the earliest. Example script. If you T3, just attack T4. If you crit there too you can kill.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Hildi Heal / Attack`}</li>
      <li parentName="ol">{`Hildi Sword of Fire`}</li>
      <li parentName="ol">{`Yusuke Attack, Hildi Revival Medicine`}</li>
      <li parentName="ol">{`Hildi Sword of Fire`}</li>
      <li parentName="ol">{`Hildi Attack`}</li>
      <li parentName="ol">{`Yusuke Attack`}</li>
    </ol>
    <h3 {...{
      "id": "nowa-group"
    }}>{`Nowa Group`}</h3>
    <h4 {...{
      "id": "party-19"
    }}>{`Party`}</h4>
    <ol>
      <li parentName="ol">{`Lian: Attendant`}</li>
      <li parentName="ol">{`Mio: Slot 5`}</li>
      <li parentName="ol">{`Yaelu to Support`}</li>
    </ol>
    <p>{`Talk to Sumire`}</p>
    <blockquote>
      <p parentName="blockquote">{`I can unequip Seign's Rune of Mighty Powers here to save 2 purchases.`}</p>
    </blockquote>
    <h4 {...{
      "id": "gear-prep---runes"
    }}>{`Gear Prep - Runes`}</h4>
    <ul>
      <li parentName="ul">{`Seign: Unequip`}</li>
      <li parentName="ul">{`Hildi:`}<ul parentName="li">
          <li parentName="ul">{`3: Rune of Abyss`}</li>
        </ul></li>
      <li parentName="ul">{`Wayve:`}<ul parentName="li">
          <li parentName="ul">{`2: Rune of Mighty Power`}</li>
          <li parentName="ul">{`5: Rune of Mighty Power`}</li>
          <li parentName="ul">{`4: Rune of Mighty Power`}</li>
        </ul></li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`4: Rune of Inferno`}</li>
        </ul></li>
      <li parentName="ul">{`Yuferius:`}<ul parentName="li">
          <li parentName="ul">{`4: Rune of Mighty Power`}</li>
        </ul></li>
    </ul>
    <h4 {...{
      "id": "samurai-revenant-4856hp"
    }}>{`Samurai Revenant 4856HP`}</h4>
    <h5 {...{
      "id": "turn-1-23"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Attack`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Mio: Fire God's Sword Garr`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-20"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Mio: Superior Revival Medicine Nowa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on-2"
    }}>{`Turn 3 & On`}</h5>
    <ul>
      <li parentName="ul">{`Auto`}</li>
    </ul>
    <h3 {...{
      "id": "marisa-group"
    }}>{`Marisa Group`}</h3>
    <h4 {...{
      "id": "party-20"
    }}>{`Party`}</h4>
    <ol>
      <li parentName="ol">{`Marisa: Swap Alwe`}</li>
      <li parentName="ol">{`Nil: Attendant`}</li>
      <li parentName="ol">{`Barnard: Slot 3`}</li>
      <li parentName="ol">{`Yuferius: Slot 6`}</li>
      <li parentName="ol">{`Kassius: Support`}</li>
    </ol>
    <h4 {...{
      "id": "3-corpse-rider-291hp-2-corpse-witch-304hp"
    }}>{`3 Corpse Rider 291HP 2 Corpse Witch 304HP`}</h4>
    <ul>
      <li parentName="ul">{`Euchrissian Cavalry`}</li>
      <li parentName="ul">{`Alwe: Flame Wall back row`}</li>
      <li parentName="ul">{`Bernard: Attack`}</li>
      <li parentName="ul">{`Marisa: Crimson Nova`}</li>
      <li parentName="ul">{`Lilwn: Wind God's Breath`}</li>
    </ul>
    <h4 {...{
      "id": "2-corpse-knight-885hp-1-spookybear-revenant-1668hp"
    }}>{`2 Corpse Knight 885HP 1 Spookybear-Revenant 1668HP`}</h4>
    <h5 {...{
      "id": "turn-1-24"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Alwe: Fire God's Sword Wayve`}</li>
      <li parentName="ul">{`Wayve: Attack Bear`}</li>
      <li parentName="ul">{`Barnard: Attack Corpse Knight`}</li>
      <li parentName="ul">{`Marisa: Crimson Nova`}</li>
      <li parentName="ul">{`Lilwn: Shield`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-21"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`If Alwe survived: Euchrissian Charge`}</em></li>
      <li parentName="ul">{`Alwe: Attack Corpse Knight 2`}</li>
      <li parentName="ul">{`Wayve: Magic Strike`}</li>
      <li parentName="ul">{`Marisa: Crimson Nova`}</li>
      <li parentName="ul">{`Lilwn: `}<em parentName="li">{`If Alwe survived and Barnard died before attacking`}</em>{` Attack Corpse Knight 1`}</li>
      <li parentName="ul">{`Yuferius: Attack Bear`}</li>
    </ul>
    <h4 {...{
      "id": "battle-3-spookybear-revenant-4228hp"
    }}>{`Battle 3 Spookybear-Revenant 4228HP`}</h4>
    <h5 {...{
      "id": "turn-1-25"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Alwe: Fire Sword Wayve`}</li>
      <li parentName="ul">{`Wayve: Attack`}</li>
      <li parentName="ul">{`Barnard: Attack`}</li>
      <li parentName="ul">{`Marisa: Fire God's Sword Yuferius`}</li>
      <li parentName="ul">{`Lilwn: Shield`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2--on-1"
    }}>{`Turn 2 & On`}</h5>
    <p>{`Pretty standard, can throw in attacks if you think you'll need damage due to lack of berserk.`}</p>
    <p>{`Run to `}<strong parentName="p">{`Twinhorne West`}</strong></p>
    <h3 {...{
      "id": "twinhorne-west"
    }}>{`Twinhorne West`}</h3>
    <blockquote>
      <p parentName="blockquote">{`No Auto-heal here for Marisa's party.`}</p>
    </blockquote>
    <h4 {...{
      "id": "party-21"
    }}>{`Party`}</h4>
    <ol>
      <li parentName="ol">{`Yusuke: Slot 3`}</li>
      <li parentName="ol">{`Francesca: Slot 4`}</li>
      <li parentName="ol">{`Mio: Swap Hildi`}</li>
      <li parentName="ol">{`Yuferius: Slot 6`}</li>
      <li parentName="ol">{`Lian: Swap Seign`}</li>
      <li parentName="ol">{`Marisa: Attendant`}</li>
    </ol>
    <h4 {...{
      "id": "experimental-specimen-a_0099-5430hp"
    }}>{`Experimental Specimen A_0099 5430HP`}</h4>
    <h5 {...{
      "id": "turn-1-26"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<strong parentName="li">{`Attack`}</strong></li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Francesca: Shield`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Garr`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-22"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack / Double Sword (Let's you kill with Yusuke Crit T3)`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Francesca: Shield`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Yusuke`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-11"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yusuke: `}<strong parentName="li">{`Attack`}</strong></li>
      <li parentName="ul">{`Hildi: Fire God's Sword Yuferius`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
    </ul>
    <h3 {...{
      "id": "castle-6"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}</p>
    <ul>
      <li parentName="ul">{`Go to Seign's Room`}</li>
      <li parentName="ul">{`Go to Marisa's Room`}</li>
      <li parentName="ul">{`Teleport `}<strong parentName="li">{`Inside Castle 1T`}</strong></li>
      <li parentName="ul">{`Go to Ymir`}</li>
    </ul>
    <p>{`Go to Great Hall`}</p>
    <p>{`Teleport to `}<strong parentName="p">{`Castle 1U`}</strong>{`. Enter the Castle. Run forward to trigger cutscene.`}</p>
    <p>{`Go to Great Hall`}</p>
    <h4 {...{
      "id": "party-22"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Markus: Attendant`}</li>
      <li parentName="ul">{`Garr: Slot 3`}</li>
      <li parentName="ul">{`Yusuke: Slot 4`}</li>
      <li parentName="ul">{`Yusuke: Swap Marisa`}</li>
      <li parentName="ul">{`Hildi: Slot 5`}</li>
      <li parentName="ul">{`Yuferius: Slot 6`}</li>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <h3 {...{
      "id": "castle-harganthia"
    }}>{`Castle Harganthia`}</h3>
    <p>{`Bring Garr, Wayve, Yusuke, Yuferius, Hildi, Marisa, Yaelu`}</p>
    <p>{`1st Flower Room:`}<br parentName="p"></br>{`
`}{`1. Left`}<br parentName="p"></br>{`
`}{`2. Bottom right of open area ahead`}</p>
    <p>{`2nd flower room:`}<br parentName="p"></br>{`
`}{`1. Top right`}<br parentName="p"></br>{`
`}{`2. Bottom right (have to wrap around bottom left)`}<br parentName="p"></br>{`
`}{`3. Top right`}</p>
    <p>{`3rd flower room:`}<br parentName="p"></br>{`
`}{`1. Up-left then bottom right.`}<br parentName="p"></br>{`
`}{`2. Bottom left`}<br parentName="p"></br>{`
`}{`3. Top left`}</p>
    <h4 {...{
      "id": "dead-countess-5102hp-20352"
    }}>{`Dead Countess 5102HP 2:03.52`}</h4>
    <h5 {...{
      "id": "turn-1-27"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Marisa: Fire God's Sword Yusuke`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Yuferius`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-23"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Marisa: Fire God's Sword Wayve`}</li>
      <li parentName="ul">{`Hildi: Fire God's Sword Garr`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-12"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Wayve: Attack`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "t4"
    }}>{`T4`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Wayve: Attack`}</li>
      <li parentName="ul">{`Garr: Double Slash`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Samurai-Revenant 524HP`}<br parentName="p"></br>{`
`}{`Spookybear-Revenant 675HP`}<br parentName="p"></br>{`
`}{`Maiden-Revenant 441HP`}<br parentName="p"></br>{`
`}{`Letting her Summon and killing those is a 2:12.99. Strat is in addendum`}</p>
    </blockquote>
    <h4 {...{
      "id": "diardhe"
    }}>{`Diardhe`}</h4>
    <p>{`Phase 1: Attack until Break`}<br parentName="p"></br>{`
`}{`Phase 2: Counter until Break. Can do 1 more Counter to fill bar for safety.`}</p>
    <h3 {...{
      "id": "castle-7"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall.`}<br parentName="p"></br>{`
`}{`Go to your room.`}</p>
    <ul>
      <li parentName="ul">{`Go to roof. Talk to Seign`}</li>
      <li parentName="ul">{`Go to 2nd floor, get Mio & Lian cutscene`}</li>
      <li parentName="ul">{`Go to Melridge room for cutscene`}</li>
      <li parentName="ul">{`Go to bed`}</li>
    </ul>
    <p>{`Go to Great Hall.`}</p>
    <h4 {...{
      "id": "war-final-battle-at-castle"
    }}>{`War: Final Battle at Castle`}</h4>
    <ul>
      <li parentName="ul">{`Move Nowa 2 Right to Skyd`}</li>
      <li parentName="ul">{`Move Bernard 1 Left to Ymir`}</li>
      <li parentName="ul">{`Move Ymir 1 Right to Kassius`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-3-1"
    }}>{`Turn 1-3`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move 1 Down`}</li>
      <li parentName="ul">{`Skyd: Move 1 Down`}</li>
      <li parentName="ul">{`Ymir: Move 1 Down`}</li>
      <li parentName="ul">{`Kassius: Move 1 Down`}</li>
      <li parentName="ul">{`Skyd: Move 1 Down`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-5"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa:`}<ul parentName="li">
          <li parentName="ul">{`Move 1 Down`}</li>
          <li parentName="ul">{`Cross Boost`}</li>
        </ul></li>
      <li parentName="ul">{`Seign:`}<ul parentName="li">
          <li parentName="ul">{`Focus Attacks Aldric`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move Left if Aldric retreated`}</li>
      <li parentName="ul">{`Ymir:`}<ul parentName="li">
          <li parentName="ul">{`Move to Aldric`}</li>
          <li parentName="ul">{`Rescue Own Unit`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Move to Aldric`}</li>
      <li parentName="ul">{`Kassius: Move to Aldric`}</li>
    </ul>
    <h3 {...{
      "id": "imperial-camp"
    }}>{`Imperial Camp`}</h3>
    <h4 {...{
      "id": "party-23"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Seign: Attendant`}</li>
      <li parentName="ul">{`Yusuke: Slot 2`}</li>
      <li parentName="ul">{`Francesca: Slot 3`}</li>
      <li parentName="ul">{`Alwe: Slot 4`}</li>
      <li parentName="ul">{`Yuferius: Slot 5`}</li>
      <li parentName="ul">{`Garr: Slot 6`}</li>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <h4 {...{
      "id": "heinrich-5196hp-2-imperial-elite-428hp"
    }}>{`Heinrich 5196HP 2 Imperial Elite 428HP`}</h4>
    <h5 {...{
      "id": "turn-1-28"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Attack`}</li>
      <li parentName="ul">{`Alwe: Fire God's Sword Garr`}</li>
      <li parentName="ul">{`Garr: Attack Heinrich`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-24"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Attack`}</li>
      <li parentName="ul">{`Alwe: Fire God's Sword Yusuke`}</li>
      <li parentName="ul">{`Garr: Attack Heinrich`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-13"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack Heinrich`}</li>
      <li parentName="ul">{`Garr: Attack / Double Slash Heinrich`}</li>
      <li parentName="ul">{`Yuferius: Attack Heinrich`}</li>
      <li parentName="ul">{`Alwe: Fire God's Sword Yuferius`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4--on"
    }}>{`Turn 4 & On`}</h5>
    <p>{`Clean up as needed.`}</p>
    <h3 {...{
      "id": "castle-8"
    }}>{`Castle`}</h3>
    <p>{`Go outside.`}<br parentName="p"></br>{`
`}{`Go to Great Hall`}</p>
    <h3 {...{
      "id": "war-recapture-of-eltisweiss"
    }}>{`War: Recapture of Eltisweiss`}</h3>
    <p>{`This battle is split into variations based off what the enemies do T1.`}</p>
    <h4 {...{
      "id": "formation"
    }}>{`Formation`}</h4>
    <ul>
      <li parentName="ul">{`Left: Ymir`}</li>
      <li parentName="ul">{`Middle: Nowa, Seign, Vorrdice`}</li>
      <li parentName="ul">{`Right: Marisa, Goldwyn`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-29"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
      <li parentName="ul">{`Goldwyn: Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "all-enemies-forward"
    }}>{`All Enemies Forward`}</h4>
    <h5 {...{
      "id": "turn-2-25"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Vorrdice: Move Left`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-14"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Focus Attacks Chappel`}</li>
      <li parentName="ul">{`Marisa: Move Left`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-6"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Cross Boost`}</li>
          <li parentName="ul">{`Scheme Right`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Assault Chappel`}</li>
        </ul></li>
      <li parentName="ul">{`Vorrdice: Move Forward`}</li>
      <li parentName="ul">{`Ymir: Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "enemy-unit-leftright"
    }}>{`Enemy Unit Left/Right`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Pay attention to the direction the unit goes, it dictates some of your moves`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-26"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Vorrdice: Move Right/Left (Opposite of enemy unit movement)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-15"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Focus Attacks Chappel`}</li>
      <li parentName="ul">{`Marisa: Move Left`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-7"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Cross Boost`}</li>
          <li parentName="ul">{`Scheme Left/Right (Side that enemy unit went to)`}</li>
        </ul></li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Assault Chappel`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Vorrdice: Move Forward`}</li>
      <li parentName="ul">{`Goldwyn/Ymir (Opposite Side of enemy unit): Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "chappel-leftright-left-untested"
    }}>{`Chappel Left/Right (Left Untested)`}</h4>
    <p>{`This variation needs a lot more testing, I have limited confidence in it.`}</p>
    <h5 {...{
      "id": "turn-2-27"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Vorrdice: Move Left/Right (Same side as Chappel)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-16"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Marisa: Move Left (If Right variation can Assault here)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-8"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<ul parentName="li">
          <li parentName="ul">{`Move Left/Right (at Chappel)`}</li>
          <li parentName="ul">{`Cross Boost`}</li>
          <li parentName="ul">{`Scheme Middle`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Focus Attacks Chappel`}</li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Assault Chappel`}</li>
          <li parentName="ul">{`Move Left/Right (at Chappel)`}</li>
        </ul></li>
      <li parentName="ul">{`Vorrdice:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Overall Boost`}</li>
          <li parentName="ul">{`Physical Boost`}</li>
        </ul></li>
      <li parentName="ul">{`Goldwyn/Ymir (Opposite Side of Chappel): Move Forward`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-2"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
      <li parentName="ul">{`Marisa: Move Forward`}</li>
      <li parentName="ul">{`Vorrdice: Move Forward`}</li>
    </ul>
    <h3 {...{
      "id": "eltisweiss-4"
    }}>{`Eltisweiss`}</h3>
    <h4 {...{
      "id": "party-24"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Nowa: Attendant`}</li>
      <li parentName="ul">{`Garr: Slot 1`}</li>
      <li parentName="ul">{`Lian: Swap Yusuke`}</li>
      <li parentName="ul">{`Alwe: Slot 3`}</li>
      <li parentName="ul">{`Markus: Slot 4`}</li>
      <li parentName="ul">{`Hildi: Slot 5`}</li>
      <li parentName="ul">{`Marisa: Slot 6`}</li>
      <li parentName="ul">{`Yulin: Support`}</li>
    </ul>
    <p>{`Talk to Sumire.`}</p>
    <h4 {...{
      "id": "gear-prep---runes-1"
    }}>{`Gear Prep - Runes`}</h4>
    <ul>
      <li parentName="ul">{`Mio: Unequip`}</li>
      <li parentName="ul">{`Marisa: `}<ul parentName="li">
          <li parentName="ul">{`2: Rune of Fire`}</li>
          <li parentName="ul">{`4: Rune of Conflagration`}</li>
          <li parentName="ul">{`4: Markus Rune of Earth`}</li>
          <li parentName="ul">{`4: Rune of the Void`}</li>
        </ul></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Imperial Elite (Sword) 428HP, Imperial Soldier (Bow) 322HP`}</p>
    </blockquote>
    <h4 {...{
      "id": "3-sword-1-bow"
    }}>{`3 Sword 1 Bow`}</h4>
    <ul>
      <li parentName="ul">{`Alwe: Flame Wall front row`}</li>
      <li parentName="ul">{`Markus: Flames of Perdition`}</li>
      <li parentName="ul">{`Marisa: Nebula Ray`}</li>
    </ul>
    <h4 {...{
      "id": "2-sword-2-bow-1"
    }}>{`2 Sword 2 Bow`}</h4>
    <ul>
      <li parentName="ul">{`Markus: Flames of Perdition`}</li>
      <li parentName="ul">{`Hildi: Nebula Ray`}</li>
    </ul>
    <h4 {...{
      "id": "1-sword-3-bow"
    }}>{`1 Sword 3 Bow`}</h4>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Hildi: Nebula Ray`}</li>
      <li parentName="ul">{`Marisa: Nether Beckoning back row`}</li>
    </ul>
    <h4 {...{
      "id": "chappel-5298hp"
    }}>{`Chappel 5298HP`}</h4>
    <h5 {...{
      "id": "turn-1-30"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack Chappel`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Alwe: Fire Sword Garr`}</li>
      <li parentName="ul">{`Markus: Flames of Perdition`}</li>
      <li parentName="ul">{`Marisa: Nebula Ray`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-28"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Alwe or Hildi: Fire Sword Yusuke`}</li>
      <li parentName="ul">{`Markus: Attack`}</li>
      <li parentName="ul">{`Marisa: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on-3"
    }}>{`Turn 3 & On`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Markus: Attack`}</li>
      <li parentName="ul">{`Marisa: Attack`}</li>
    </ul>
    <h3 {...{
      "id": "castle-9"
    }}>{`Castle`}</h3>
    <p>{`Go to Great Hall`}<br parentName="p"></br>{`
`}{`Go to your room.`}</p>
    <h3 {...{
      "id": "liberation-of-the-ducal-territory"
    }}>{`Liberation of the Ducal Territory`}</h3>
    <p>{`This battle is split into variations based off what the enemies do T1.`}</p>
    <h4 {...{
      "id": "formation-1"
    }}>{`Formation`}</h4>
    <ul>
      <li parentName="ul">{`Left: Kassius, Goldwyn`}</li>
      <li parentName="ul">{`Middle: Nowa, Seign, Marisa`}</li>
      <li parentName="ul">{`Right: Elektra, Vorrdice`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-31"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Middle: Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "all-forward"
    }}>{`All Forward`}</h4>
    <h5 {...{
      "id": "turn-2-29"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Focus Attacks Aldric`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-17"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Left: Move Left`}</li>
      <li parentName="ul">{`Right: Move Right`}</li>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Assault Aldric`}</li>
          <li parentName="ul">{`Draw Out Aldric`}</li>
        </ul></li>
      <li parentName="ul">{`Left: Move Down`}</li>
      <li parentName="ul">{`Right: Move Down`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-9"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Middle: Move Forward`}</li>
      <li parentName="ul">{`Left/Right: If enemy went to edge T3, move back towards middle.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-3"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
    </ul>
    <h4 {...{
      "id": "unit-left-or-right"
    }}>{`Unit Left or Right`}</h4>
    <p>{`This one is looking somewhat inconsistent, needs more testing. The issue is that sometimes you have to fight 3 units T4, and you don't win. Can generally still recover it though.`}</p>
    <p>{`Maybe better to push side units forward, right, forward from the start for this pattern? Might lure some of the center away?`}</p>
    <h5 {...{
      "id": "turn-2-30"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Seign: Focus Attacks Aldric`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-18"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Left: Move Left`}</li>
      <li parentName="ul">{`Right: Move Right`}</li>
      <li parentName="ul">{`Nowa: Move Forward`}</li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Draw Out Aldric`}</li>
          <li parentName="ul">{`Assault Aldric`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "turn-4-10"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Scheme Narungarde / Most threatening side unit if there is one`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa: Move Forward`}</li>
      <li parentName="ul">{`Left/Right: If enemy went to edge T3, move back towards middle.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-4"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Middle: Move Forward 2 Units`}</li>
    </ul>
    <h4 {...{
      "id": "aldric-left-or-right"
    }}>{`Aldric Left or Right`}</h4>
    <h5 {...{
      "id": "turn-2-31"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Left: Move Forward`}</li>
      <li parentName="ul">{`Right: Move Forward`}</li>
      <li parentName="ul">{`Middle: Move Forward`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-19"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: Cross Boost`}</li>
      <li parentName="ul">{`Seign: Focus Attacks Aldric`}</li>
      <li parentName="ul">{`Marisa:`}<ul parentName="li">
          <li parentName="ul">{`Assault Aldric`}</li>
          <li parentName="ul">{`Draw Out Aldric`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "turn-4-11"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Nowa: `}<ul parentName="li">
          <li parentName="ul">{`Move Forward`}</li>
          <li parentName="ul">{`Scheme Narungarde`}</li>
        </ul></li>
      <li parentName="ul">{`Seign: Move Forward`}</li>
      <li parentName="ul">{`Marisa: Move Forward`}</li>
      <li parentName="ul">{`Kassius: Provoke`}</li>
      <li parentName="ul">{`Right: Move Back`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Middle: Move Forward`}</li>
    </ul>
    <h3 {...{
      "id": "gardhaven"
    }}>{`Gardhaven`}</h3>
    <h4 {...{
      "id": "party-25"
    }}>{`Party`}</h4>
    <ul>
      <li parentName="ul">{`Seign: Attendant`}</li>
      <li parentName="ul">{`Yusuke: Slot 2`}</li>
      <li parentName="ul">{`Francesca: Slot 4`}</li>
      <li parentName="ul">{`Garr: Slot 5`}</li>
      <li parentName="ul">{`Yuferius: Slot 6`}</li>
      <li parentName="ul">{`Yaelu: Support`}</li>
    </ul>
    <h4 {...{
      "id": "library"
    }}>{`Library`}</h4>
    <h5 {...{
      "id": "1st-book-left-statue"
    }}>{`1st Book (Left Statue)`}</h5>
    <p>{`Go right, 2nd bookcase after bend.`}</p>
    <h5 {...{
      "id": "2nd-book-right-statue"
    }}>{`2nd Book (Right Statue)`}</h5>
    <ul>
      <li parentName="ul">{`Go left, up stairs, into opened staircase. `}</li>
      <li parentName="ul">{`Wrap around to right side, take stairs down.`}</li>
      <li parentName="ul">{`Go right, get chest.`}</li>
      <li parentName="ul">{`Go back the way you came.`}</li>
    </ul>
    <h5 {...{
      "id": "3rd-book-center-statue"
    }}>{`3rd Book (Center Statue)`}</h5>
    <ul>
      <li parentName="ul">{`Go right, take newly revealed staircase up.`}</li>
      <li parentName="ul">{`Go left after staircase. Take new staircase down.`}</li>
      <li parentName="ul">{`Go left, check 6th bookcase.`}</li>
      <li parentName="ul">{`Go back the way you came.`}</li>
    </ul>
    <h4 {...{
      "id": "narungarde-6905hp"
    }}>{`Narungarde 6905HP`}</h4>
    <h5 {...{
      "id": "turn-1-32"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Narungarde`}</em>{`: Nebula Ray`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Marisa: Fire God's Sword Garr`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yuferius: `}<strong parentName="li">{`Spirit Medicine`}</strong></li>
    </ul>
    <h5 {...{
      "id": "turn-2-32"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Narungarde`}</em>{`: 2 Rock Thrusts`}</li>
      <li parentName="ul">{`Yusuke: Charge`}</li>
      <li parentName="ul">{`Marisa: Fire God's Sword Yusuke`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-20"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Narungarde`}</em>{`: 2 Single Targets (can double tap Marisa)`}</li>
      <li parentName="ul">{`Yusuke: Armor Pierce`}</li>
      <li parentName="ul">{`Marisa: Fire God's Sword Yuferius / Spirit Medicine (cautious safety, shouldn't be needed)`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yuferius: Charge / Can Attack here hoping for Crit from Yusuke. If no Crit, Garr should still kill T4.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-12"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Narungarde`}</em>{`: Can do AoE or something else, damage threshold?`}</li>
      <li parentName="ul">{`Yusuke: Armor Pierce`}</li>
      <li parentName="ul">{`Marisa: Spirit Medicine`}</li>
      <li parentName="ul">{`Garr: Attack`}</li>
      <li parentName="ul">{`Yuferius: Charge`}</li>
    </ul>
    <p>{`Heal after the battle with Francesca Recovery Waves or Spirit Medicine`}</p>
    <h4 {...{
      "id": "alde-dracere-7344hp"
    }}>{`Alde Dracere 7344HP`}</h4>
    <p>{`Fight is standard Swords + Charge stuff. Try to get a Spirit Medicine in before the end of the fight.`}<br parentName="p"></br>{`
`}{`He will kidnap a character T4 (Damage Threshold), fight takes 6-7 turns.`}</p>
    <h4 {...{
      "id": "alde-dracere-4166hp"
    }}>{`Alde Dracere 4166HP`}</h4>
    <h5 {...{
      "id": "turn-1-33"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Defend / Spirit Medicine`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-33"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Garr: Attack / Double Slash`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-21"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Yusuke: Attack`}</li>
      <li parentName="ul">{`Garr: Attack / Double Slash`}</li>
      <li parentName="ul">{`Yuferius: Attack`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Enemy pattern is`}<br parentName="p"></br>{`
`}{`1. Fires of the Apocalypse (AoE)`}<br parentName="p"></br>{`
`}{`2. Shield of Abnegation`}<br parentName="p"></br>{`
`}{`3. Meteor of Ruin (weaker AoE) (Killed him here) / Heal himself for 400`}</p>
    </blockquote>
    <h3 {...{
      "id": "aldric-duel"
    }}>{`Aldric Duel`}</h3>
    <h4 {...{
      "id": "nowa"
    }}>{`Nowa`}</h4>
    <ol>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
    </ol>
    <h4 {...{
      "id": "seign"
    }}>{`Seign`}</h4>
    <ol>
      <li parentName="ol">{`Counter`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Depends`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`Attack - Aldric: You will not sway me from my path!`}</li>
      <li parentName="ul">{`Counter - Seign: I will not turn away from what I know to be right!`}</li>
    </ul>
    <h4 {...{
      "id": "marisa"
    }}>{`Marisa`}</h4>
    <p>{`Counter till victory.`}</p>
    <p>{`Break, timing ends after next cutscene skip. GG!`}</p>
    <h2 {...{
      "id": "addendum"
    }}>{`Addendum`}</h2>
    <h3 {...{
      "id": "dead-countess-alt-strat"
    }}>{`Dead Countess Alt Strat`}</h3>
    <h4 {...{
      "id": "dead-countess---kill-summon-strat-21299"
    }}>{`Dead Countess - Kill Summon Strat: 2:12.99`}</h4>
    <h5 {...{
      "id": "turn-1-34"
    }}>{`Turn 1`}</h5>
    <p>{`Yusuke: Attack`}<br parentName="p"></br>{`
`}{`Wayve: Attack`}<br parentName="p"></br>{`
`}{`Garr: Attack`}<br parentName="p"></br>{`
`}{`Marisa: Fire God's Sword Wayve`}<br parentName="p"></br>{`
`}{`Hildi: Fire God's Sword Garr`}<br parentName="p"></br>{`
`}{`Yuferius: Charge`}</p>
    <h5 {...{
      "id": "turn-2-34"
    }}>{`Turn 2`}</h5>
    <p>{`Yusuke: Charge`}<br parentName="p"></br>{`
`}{`Wayve: Attack`}<br parentName="p"></br>{`
`}{`Garr: Attack`}<br parentName="p"></br>{`
`}{`Marisa: Crimson Nova`}<br parentName="p"></br>{`
`}{`Hildi: Nebula Ray`}<br parentName="p"></br>{`
`}{`Yuferius: Charge`}</p>
    <h5 {...{
      "id": "turn-3-22"
    }}>{`Turn 3`}</h5>
    <p>{`Yusuke: Charge`}<br parentName="p"></br>{`
`}{`Wayve: Magic Barrage`}<br parentName="p"></br>{`
`}{`Garr: Attack`}<br parentName="p"></br>{`
`}{`Marisa: Fire God's Sword Yuferius`}<br parentName="p"></br>{`
`}{`Hildi: Fire God's Sword Yusuke`}<br parentName="p"></br>{`
`}{`Yuferius: Attack`}</p>
    <h5 {...{
      "id": "turn-4-13"
    }}>{`Turn 4`}</h5>
    <p>{`Auto`}</p>
    <h3 {...{
      "id": "primordial-gear"
    }}>{`Primordial Gear`}</h3>
    <p>{`Shows up after final speech after Heinrich aka point of no return`}<br parentName="p"></br>{`
`}{`Rune Research Factory one might be a decent choice, +8 +8 +32 +32 and not too bad to get.`}</p>
    <h3 {...{
      "id": "battle-count-with-no-monster-repel-charm"
    }}>{`Battle Count with no Monster Repel Charm`}</h3>
    <p>{`Eldroad: 1 (Post Dragon)`}<br parentName="p"></br>{`
`}{`Ice Cave: 0`}<br parentName="p"></br>{`
`}{`Harganthia: 0`}<br parentName="p"></br>{`
`}{`Imperial Army Headquarters: 4`}<br parentName="p"></br>{`
`}{`Gardhaven: 5? in library`}</p>
    <h4 {...{
      "id": "snowpeak"
    }}>{`Snowpeak`}</h4>
    <p>{`Seign: 1`}<br parentName="p"></br>{`
`}{`Marisa: 1`}<br parentName="p"></br>{`
`}{`Nowa: 1`}</p>
    <h4 {...{
      "id": "revenants"
    }}>{`Revenants`}</h4>
    <p>{`Seign: 1`}<br parentName="p"></br>{`
`}{`Nowa: 0`}<br parentName="p"></br>{`
`}{`Marisa: 1`}<br parentName="p"></br>{`
`}{`Run to Twinhorne: 0`}</p>
    <h3 {...{
      "id": "multipliers"
    }}>{`Multipliers`}</h3>
    <p>{`Crit is 1.5x, berserk is 1.5x, atk+ is 1.25x`}<br parentName="p"></br>{`
`}{`Each Growth Ring adds 20% of base EXP. So 6 Growth Rings = 2.2x EXP`}</p>
    <h3 {...{
      "id": "timings"
    }}>{`Timings`}</h3>
    <p>{`Battle escape takes about 8.2s`}<br parentName="p"></br>{`
`}{`S&Q takes about 6.3s`}</p>
    <h3 {...{
      "id": "runeshards-of-return-count"
    }}>{`Runeshards of Return Count`}</h3>
    <ol>
      <li parentName="ol">{`Mines Earth Rune`}</li>
      <li parentName="ol">{`Mines Iron Ore`}</li>
      <li parentName="ol">{`Proving Grounds`}</li>
      <li parentName="ol">{`Proving Grounds`}</li>
      <li parentName="ol">{`Gardhaven`}</li>
      <li parentName="ol">{`Gardhaven`}</li>
      <li parentName="ol">{`Proving Grounds Gear Activation`}</li>
      <li parentName="ol">{`Proving Grounds Gear Activation`}</li>
    </ol>
    <h3 {...{
      "id": "starting-stats"
    }}>{`Starting Stats`}</h3>
    <p>{`Everyone starts at LVL1`}<br parentName="p"></br>{`
`}{`Starting items: 6 Healing herbs`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "51424"
    }}>{`5/14/24`}</h4>
    <ul>
      <li parentName="ul">{`Initial Upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      